import { render, staticRenderFns } from "./HuichuanEvents.vue?vue&type=template&id=990a913e&scoped=true"
import script from "./HuichuanEvents.vue?vue&type=script&lang=js"
export * from "./HuichuanEvents.vue?vue&type=script&lang=js"
import style0 from "./HuichuanEvents.vue?vue&type=style&index=0&id=990a913e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990a913e",
  null
  
)

export default component.exports